var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader'),_c('notifications',{attrs:{"position":"center right","classes":"kkk-notification"}}),_c('router-view'),_c('AppFooter'),_c('cookie-banner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }